// extracted by mini-css-extract-plugin
export default {"articleCard":"ArticleCard_articleCard__D8Qob","title":"ArticleCard_title__uPVMx","description":"ArticleCard_description__v8Qqr"};